let address_components = null;

function get(type, short = false) {
  for (let component of address_components) {
    if (component.types.includes(type)) {
      return short ? component.short_name : component.long_name;
    }
  }
  return null;
}

export default {
  parsePlace(place) {
    address_components = place.address_components;

    const result = {
      street_number: get('street_number'),
      street_name:   get('route'),
      city:          get('locality'),
      county:        get('administrative_area_level_2'),
      state_short:   get('administrative_area_level_1', true),
      state_long:    get('administrative_area_level_1'),
      country_short: get('country', true),
      country_long:  get('country'),
      zip_code:      get('postal_code')
    };

    if(result.street_number && result.street_name) {
      result.address = result.street_number + ' ' + result.street_name;
    }
    else if(result.street_name) {
      result.address = result.street_name;
    }
    else {
      result.address = '';
    }

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/modules/place-parser.js